/* Scroll functions */
(function( ) {
    'use strict'

    /* Setup */
    const events = {
        'scrolled': new Event('scrolled')
    }
    let timeoutIds = {
        'scrolled': 0
    }

    /* Check in the beginnning */
    checkScroll()

    /* Toggle scrolled state */
    document.addEventListener('scroll', () => {
        if ( window.scrollY > 0 ) {
            document.querySelector( 'body' ).classList.add( 'is-scrolled' )
        } else {
            document.querySelector( 'body' ).classList.remove( 'is-scrolled' )
        }

        /* Dispatch event */
        clearTimeout(timeoutIds['scrolled'])
        timeoutIds['scrolled'] = setTimeout(() => { window.dispatchEvent(events['scrolled']) }, 250)
    })

    function checkScroll() {
        if ( window.scrollY > 0 ) {
            document.querySelector( 'body' ).classList.add( 'is-scrolled' )
        } else {
            document.querySelector( 'body' ).classList.remove( 'is-scrolled' )
        }
    }
})( )
